import { mapGetters, mapActions } from "vuex";
const minxinActive = {
  data() {
    return {
      validator: null, // 极致验证
      active: this.$ls.get("active") || 0
    };
  },
  computed: {
    ...mapGetters(["headerShow", "leave"])
  },
  methods: {
    ...mapActions(["SetHeaderShow", "SetLeave"]),
    /**
     * @description 根据名称与步骤值找到对应的值
     * @param {number} activeIndex  - 索引
     * @param {string} name  - 表单项名称
     */
    findField(activeIndex, name) {
      let fieldObj = this.dataList[activeIndex].filed.find(
        item => item.name === name
      );
      return fieldObj;
    },

    /**
     * @description 重置值为空
     * @param {number} activeIndex  - 索引
     * @param {string} name  - 表单项名称
     */
    resetFieldValue(activeIndex, name) {
      this.$set(this.findField(activeIndex, name), "value", "");
      this.$ls.set("dataList", this.dataList);
    },
    /**
     * @description 赋值
     * @param {number} activeIndex  - 索引
     * @param {string} name - 表单项名称
     * @param {string} value  - 表单项值
     * @param {string} key  - 表单项的key
     */
    setFieldValue(activeIndex, name, value, key = "value") {
      this.$set(this.findField(activeIndex, name), key, value);
      this.$ls.set("dataList", this.dataList);
    },
    /**
     * @description  获取值
     * @param {number} activeIndex  - 索引
     * @param {string} name - 表单项名称
     * @param {string} value  - 表单项值
     * @param {string} key  - 表单项的key
     */
    getFieldValue(activeIndex, name, key = "value") {
      let obj = this.findField(activeIndex, name);
      return obj[key];
    },
    /**
     * @description 控制表单按钮显示
     */
    handlerForm() {
      if (!this.$refs.form) return;
      this.$refs.form.disabled = false;
    },
    /**
     * @description 实时赋值
     */
    giveData(index, name, value) {
      this.setFieldValue(index, name, value);
      this.$ls.set("dataList", this.dataList);
    },
    /**
     * @description picker控制选项
     */
    handlerAction(index) {
      this.actions = this.data[index].actions;
    },
    /**
     * @description 设置步骤继续一步
     */
    setActive() {
      this.active = this.active + 1;
      this.$ls.set("active", this.active);
    },
    /**
     * @description 设置步骤退到上一步
     */
    backActive() {
      this.active = this.active - 1;
      this.$ls.set("active", this.active);
    },
    /**
     * @description 缓存移除
     */
    lsRemove(list) {
      if (list.length == 0) return;
      list.forEach(item => {
        this.$ls.remove(item);
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    //控制头部显示
    if (this.headerShow) {
      this.SetHeaderShow(false);
    }
    //直接离开页面
    if (this.leave) {
      this.removeAll();
      next();
      return false;
    }
    //页面内步骤返回操作
    let routerList = [
      "findPassword",
      "appealSubmit",
      "appealFind",
      "clearLock",
      "lockAccount",
      "back"
    ];
    if (routerList.includes(from.name)) {
      if (!this.goBack()) {
        return false;
      }
    } else if (this.active != 0) {
      this.backActive();
      return false;
    }
    this.removeAll();
    next();
  }
};

export { minxinActive };
